import React, { useEffect, useState } from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  const [buttonLink, setButtonLink] = useState('https://redcap.ru.is/surveys/?s=3RP9HY7CTH9R79E3');

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const currentDomain = window.location.hostname;
    
    if (currentDomain === 'skoli.flikk.is') {
      setButtonLink('https://redcap.ru.is/surveys/?s=NLA788WH83ATY3HD');
    } else {
      setButtonLink('https://redcap.ru.is/surveys/?s=NTH99F3CHDCNHHMR');
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // This enables smooth scrolling
    });
  };


  return (
      <div className="App">
      {/* Navbar */}
      <nav className="navbar">
        <div className="container">
          <a href="#home" onClick={scrollToTop} className="logo">
          <img className="logo-desktop" src="logo_clean.png" alt="FLIKK" />
          <img className="logo-mobile" src="logo_mobile.png" alt="FLIKK" />
          </a>
          <ul>
          <li><a href="#about">Um FLIKK</a></li>
          <li><a href="#benefits">Ávinningur</a></li>
          <li><a href="#home" onClick={scrollToTop}>Skráning</a></li>
          </ul>
        </div>
      </nav>

      {/* CTA Section */}
      <header className="cta">
        <div className="container" id="home">
            <h1>Er barnið þitt að glíma við kvíða?</h1>
            <p>ForeldraLausn og Internetmeðferð fyrir Kvíðna Krakka (FLIKK) hjálpar ykkur að takast á við kvíða barnsins þíns.</p>
            <p>Smelltu á takkann hér fyrir neðan til að fá frekari upplýsingar og skrá þig í FLIKK.</p>
            <a href={buttonLink} target="_blank" rel="noopener noreferrer">
              <button>Skráning</button>
            </a>
        </div>
      </header>


      {/* Main Content */}
      <main className="main-content">
        <section className="section" id="about">
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Hvað er FLIKK?</h2>
              <p>
              FLIKK stendur fyrir „ForeldraLausn og Internetmeðferð fyrir Kvíðna Krakka“. FLIKK er rannsóknarverkefni sem metur árangur og ánægju af foreldramiðaðri kvíðameðferð sem veitt er með stafrænni heilbrigðislausn í gegnum internetið. Markmiðið er að valdefla foreldra í að hjálpa börnum sínum að ná tökum á kvíðavanda og auka aðgengi að gagnreyndri meðferð. Gögnum verður safnað í Háskólanum í Reykjavík (HR) í gegnum stafrænu heilbrigðislausnina FLIKK (e. digital platform).  
              </p>
            </div>
            <div className="image">
              <img src="image1.jpg" alt="Research visual" />
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Hver er tilgangurinn með FLIKK? </h2>
              <p>
              Stefnt er að því að gjörbylta aðgengi að gagnreyndri meðferð við kvíðavanda barna hér á landi með því að nota þessa nýju stafrænu heilbrigðislausn. Hún er hönnuð og þróuð með það að leiðarljósi að valdefla foreldra kvíðinna barna á aldrinum 5 til 12 ára í að hjálpa börnum sínum að yfirstíga sinn kvíðavanda. Í rannsókn þessari munum við rannsaka hvort úrræðið skilar árangri í bættri líðan. Það verður gert með því að skoða svör foreldra spurningalistum. Sú niðurstaða mun þó ekki nýtast þér beint kæri þátttakandi, heldur einvörðungu koma fram á sjónarsviðið eftir að rannsóknum lýkur á þeim gögnum sem safnað verður. Niðurstöðurnar verða einnig nýttast til að þróa meðferðina enn frekar og því nýtast þeim foreldrum sem munu þurfa á aðstoð að halda síðar. Enn fremur miðar FLIKK að því að finna nýjar leiðir til að meðhöndla kvíðavanda hjá börnum til að koma í veg fyrir að frekari truflun fyrir barnið og er stafræna heilbrigðislausnin þróuð með það markmið að leiðarljósi. 	
              </p>
            </div>
            <div className="image">
              <img src="image2.jpg" alt="Research visual" />
            </div>
          </div>
        </section>

        <section className="section" >
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Hvernig virkar FLIKK? </h2>
              <p>
              FLIKK er netmeðferð með stuðningi frá sálfræðingi þar sem foreldrar læra aðferðir hugrænnar atferlismeðferðar til þess að hjálpa börnum sínum að yfirstíga truflandi kvíða. Netmeðferðin samanstendur af sjö meðferðarhlutum sem eru gefnir út vikulega og foreldrar fá einnig vikuleg símtöl við sálfræðing sem aðstoðar þau við að fylgja eftir meðferðinni. Hver meðferðarhluti fylgir svipaðri uppbyggingu þar sem foreldrar fylla út spurningalista í upphafi hvers meðferðarhluta og í framhaldi af því vinna með efni meðferðarhlutans. Það tekur u.þ.b. 30 mínútur að ljúka hverjum meðferðarhluta og flestir foreldrar ljúka meðferðinni á sjö vikum.  	
              </p>
            </div>
            <div className="image">
              <img src="image3.jpg" alt="Research visual" />
            </div>
          </div>
        </section>


        <section className="section">
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Kvíðavandi barna</h2>
              <p>
              Kvíðaraskanir eru meðal algengustu geðraskana sem hrjá fólk. Rannsóknir gefa til kynna að allt að 30% einstaklinga muni á einhverjum tímapunkti á lífsleiðinni þróa með sér kvíðaröskun, þar sem kvíðavandinn verður það mikill að hann hindrar eða skerðir verulega daglegt líf einstaklingsins. Helmingur allra kvíðaraskana þróast fyrir 12 ára aldur og þau börn sem ekki fá faglega aðstoð eru í aukinni hættu á að þróa með sér frekari geðrænan vanda seinna á lífsleiðinni. Þar sem bið er oft löng eftir meðferð og aðgengi takmarkað er augljóst að hugsa þarf nýjar leiðir til að aðstoða börn með kvíðavanda. FLIKK er ný aðferð við að veita meðferð sem er líkleg til árangurs og gæti verið ein leið til að gera foreldrum kleift að hjálpa börnum sínum að sigrast á ótta sínum.   
              </p>
            </div>
            <div className="image">
              <img src="image2.png" alt="flikk" />
            </div>
          </div>
        </section>

        <section className="section" id="benefits">
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Hver er ávinningur með þátttöku minni í þessari rannsókn?</h2>
              <p>
              Með þátttöku þinni í rannsókninni stendur þér til boða að þiggja gagnreynda sálfræðimeðferð við kvíðavanda barnsins þíns. Meðferðin hefur verið rannsökuð erlendis og árangur verið góður auk þess sem foreldrar hafa verið ánægðir með hana. Auk þess mun þátttaka þín í þessari rannsókn veita okkur mikilvægar upplýsingar til að þróa meðferðina áfram, auka skilning á kvíðavanda barna hér á landi og meðferð við þeim sem mun hjálpa fleiri fjölskyldum sem glíma við kvíðavanda. Rannsóknin er þátttakendum að kostnaðarlausu.
              </p>
            </div>
            <div className="image">
              <img src="image4.jpg" alt="flikk" />
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container" data-aos="fade-up">
            <div className="text">
              <h2>Fyrir hverja er FLIKK?</h2>
              <p>
              Ef þú telur að barnið þitt sé að glíma við kvíða, er á aldrinum 5-12 ára og vilt fá aðstoð, þá bjóðum við þér að fara á hlekkinn hér að neðan þar sem þú getur skráð þig í rannsóknina. Þegar þú skráir þig í rannsóknina biðjum við þig að svara spurningum til þess að við getum metið hvort að meðferðin henti þér og barni þínu.
              </p>
              <p>
                <a href="https://redcap.ru.is/surveys/?s=NTH99F3CHDCNHHMR" target="_blank" rel="noopener noreferrer">
                  <button>Skráðu þig til að fá frekari upplýsingar</button>
                </a>
              </p>
            </div>
            <div className="image">
              <img src="image3.png" alt="flikk" />
            </div>
          </div>
        </section>

      </main>
      
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-columns">
          {/* Privacy Policy Column */}
          <div className="footer-column">
            <p>
            &copy; {new Date().getFullYear()} ForeldraLausn og Internetmeðferð fyrir Kvíðna Krakka (FLIKK). Öll réttindi áskilin.
            </p>
          </div>

          <div className="footer-column">
            <p>
              <strong>Persónuverndarstefna</strong> <br />
              Þessi vefsíða safnar engum persónuupplýsingum, notar ekki vafrakökur og fylgist ekki með notendum. Hún er eingöngu til upplýsinga.
            </p>
          </div>

          {/* Imprint Column */}
          <div className="footer-column">
            <p>
              <strong>Skilmálar</strong> <br />
              Þessi vefsíða er rekin af  <br />
              <br />
              Háskóla Reykjavíkur <br />
              Menntavegur 1 <br />
              IS-102 Reykjavík<br />
              <br />
              Fyrir fyrirspurnir vinsamlegast hafðu samband við okkur á <a href="mailto:flikksupport@ru.is">flikksupport@ru.is</a>.
            </p>
          </div>
        </div>
        </div>
      </footer>
    </div>
  );
};

// Add this script at the end of your body or in your JS file
window.addEventListener('DOMContentLoaded', function() {
  function adjustCtaPadding() {
    const header = document.querySelector('.navbar');
    const cta = document.querySelector('.cta');
    if (header && cta) {
      const headerHeight = header.offsetHeight;
      cta.style.paddingTop = (headerHeight + 40) + 'px';
    }
  }

  adjustCtaPadding();
  window.addEventListener('resize', adjustCtaPadding);
});


export default App;
